<template>
  <v-layout class="ma-0 pa-0" column>
    <vue-snotify></vue-snotify>
    <v-row>
      <!--users-datatable-col -->
      <v-col cols="12" xs="12" :sm="colsNumber" :md="colsNumber">
        <v-card width="100%" class="mx-auto" flat>
          <!--users-title -->
          <v-card-title
            class="headline font-weight-regular justify-space-between primary--text"
          >
            Users
            <v-spacer></v-spacer>
          
            <v-btn
              class="mx-2"
              fab
              dark
              color="primary"
              @click="
                exportCSVFile(headersCSV, formatExportUsers, 'users-table')
              "
            >
              <v-icon class="btn-icons">icons8-export-csv</v-icon></v-btn
            >

            <v-btn
              class="mx-2"
              fab
              dark
              color="primary"
              @click="changeWindowsFlag = !changeWindowsFlag"
            >
              <v-icon dark>icons8-plus-math-2</v-icon>
            </v-btn>
          </v-card-title>
          <!--/users-title -->
          <v-divider class="secondary mx-4"></v-divider>
          <!-- filters-->
          <v-row class="mx-2">
            <v-col cols="12" xs="12" sm="6" md="2">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="datesRange"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="datesRange"
                  label="Date"
                  append-icon="icons8-filter-3"
                  solo
                  readonly
                  v-on="on"
                  hide-details="auto"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(datesRange)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="2">
               <v-select
                  v-model="schoolNameFilter"
                  label="School Name"
                  append-icon="icons8-filter-3"
                  :items="filterSchools"
                  solo
                  hide-details="auto"
                  clearable
                ></v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="2">
               <v-autocomplete
                  v-model="locationFilter"
                  label="Location"
                  append-icon="icons8-filter-3"
                  :items="filterLocationDropdown"
                  solo
                  clearable
                  item-text="name"
                  hide-details="auto"
                ></v-autocomplete>
            </v-col>

             <v-col cols="12" xs="12" sm="6" md="2">
               <v-select
                  v-model="marketingCheckboxFilter"
                  label="Marketing"
                  append-icon="icons8-filter-3"
                  :items="mCb"
                  item-text="name"
                  item-value="value"
                  solo
                  hide-details="auto"
                  clearable
                ></v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="6" md="2">
               <v-select
                  v-model="dataProcessingCheckboxFilter"
                  :items="dCb"
                  item-text="name"
                  item-value="value"
                  label="Data Processing"
                  append-icon="icons8-filter-3"
                  solo
                  hide-details="auto"
                  clearable
                ></v-select>
            </v-col>

              <v-col cols="12" xs="12" sm="6" md="2">
               <v-select
                  v-model="userLevelFilter"
                  :items="userLevelItems"
                  item-text="name"
                  item-value="value"
                  label="User Level"
                  append-icon="icons8-filter-3"
                  solo
                  hide-details="auto"
                  clearable
                ></v-select>
            </v-col>
          </v-row>

          <v-card-text class="text-left mt-4">
            <span class="grey--text text--darken-1">
              Use the fielters above or the search bar below to display the data you are looking for in the table below.
            </span>
            <v-text-field
              v-model="search"
              class="mb-2"
              append-icon="icons8-search-2"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <!--users-datatable -->
            <v-data-table
              :headers="headers"
              :items="filterUsers"
              :search="search"
              item-key="id"
              single-select
            >
              <template v-slot:[`item.accountCreatedAt`]="{ item }">
                <span class="text-capitalize">{{
                  formatDate(item.accountCreatedAt)
                }}</span>
              </template>

              <template v-slot:[`item.WGRating`]="{ item }">
                <v-icon :color="item.WGRating"
                  >icons8-goal</v-icon
                >
              </template>

               <template v-slot:[`item.marketingCheckbox`]="{ item }">
                <v-icon v-if="item.marketingCheckbox === true" class="secondary--text"
                  >icons8-checked-checkbox</v-icon
                >

                <v-icon v-else>icons8-unchecked-checkbox</v-icon>
              </template>

              <template v-slot:[`item.dataProcessingCheckbox`]="{ item }">
                <v-icon v-if="item.dataProcessingCheckbox === true" class="secondary--text"
                  >icons8-checked-checkbox</v-icon
                >
                <v-icon v-else>icons8-unchecked-checkbox</v-icon>
              </template>

              
               <template v-slot:[`item.suspendUser`]="{ item }">
                <v-icon v-if="item.suspendUser === true" class="secondary--text"
                  >icons8-checked-checkbox</v-icon
                >

                <v-icon v-else>icons8-unchecked-checkbox</v-icon>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-row align="end" justify="end" class="mr-1">
                  <v-icon
                    medium
                    class="mr-2 tableForeground--text font-weight-bold"
                    @click="editItem(item)"
                  >
                    icons8-edit
                  </v-icon>
                  <v-icon
                    medium
                    class=" tableForeground--text font-weight-bold"
                    @click="deleteItem(item)"
                  >
                    icons8-delete-bin
                  </v-icon>
                </v-row>
              </template>
            </v-data-table>
            <!--/users-datatable -->
          </v-card-text>
        </v-card>
      </v-col>
      <!--/users-datatable-col -->

      <!--edit-users-col -->
      <v-col
        cols="12"
        xs="12"
        :sm="colsNumber"
        :md="colsNumber"
        v-if="editUserFlag === true"
        class="greyBackground"
      >
        <v-card class="mx-auto greyBackground" flat>
          <v-card-title
            class="headline font-weight-regular justify-space-between py-7"
            >Edit Admin User
          <v-spacer> </v-spacer>
            <v-btn
        class="mx-2"
        dark
        color="primary"
        @click="suspendUserFunction()"
      >
      {{buttonText}} 
      </v-btn>
          </v-card-title>
          <v-divider class="secondary"></v-divider>
          <v-card-text class="text-left mx-2">
            <span class="grey--text text--darken-1">
              Use the fields below to modify the selected user.
            </span>
            <!--edit-users-form -->
            <v-form ref="editForm" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-text-field
                    v-model="editUserForm.fullName"
                    outlined
                    label="Full Name"
                    hide-details="auto"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="6">
                  <v-select
                    v-model="editUserForm.userTypeId"
                    :items="usersLevel"
                    :menu-props="{ bottom: true, offsetY: true }"
                    placeholder="Full Name"
                    outlined
                    label="User Level"
                    append-icon="icons8-expand-arrow-3"
                    hide-details="auto"
                    required
                  ></v-select>
                </v-col>
                <!--School-->
                 <v-col cols="12" xs="12" sm="6" md="6" v-if="editUserForm.userTypeId === '10'">
                  <v-text-field
                    v-model="editUserForm.schoolName"
                    outlined
                    label="School Name"
                    append-icon="icons8-school-2"
                    hide-details="auto"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <!--Locations -->
                <v-col cols="12" xs="12" sm="6" md="6" v-if="editUserForm.userTypeId === '10'">
                  <v-autocomplete
                    v-model="editUserForm.location"
                    :items="locationDropdown"
                    :filter="customFilter"
                    outlined
                    item-text="name"
                    label="Location"
                    append-icon="icons8-location-2"
                    hide-details="auto"
                    required
                  ></v-autocomplete>
                </v-col>
                 <!--Free School Meal Perchentage-->
                <v-col cols="12" xs="12" sm="6" md="6"
                  v-if="getLocationWelshValue(editUserForm.location)=='true'"> 
                  <v-text-field
                    v-model.trim="editUserForm.freeSchoolMeals"
                    outlined
                    label="Free School Meals Percentage"
                    append-icon="icons8-percentage"
                    hide-details="auto"
                    :rules="percentageOfFreeSchoolMeals"
                    required
                  ></v-text-field> 
                </v-col>
                <!--WG Rating-->
                <v-col cols="12" xs="12" sm="6" md="6"
                 v-if="getLocationWelshValue(editUserForm.location)=='true'">
                  <v-autocomplete
                    v-model="editUserForm.WGRating"
                    :items="WelshRating"
                    item-text="name"
                    item-value="value"                   
                    outlined
                    label="Welsh Government School Categorisation"
                    hide-details="auto"
                    :rules="WGRatingRule"
                    required
                  ><v-icon slot="append" :color="editUserForm.WGRating">icons8-goal</v-icon></v-autocomplete>
                </v-col>
                 <!-- The Marketing checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="editUserForm.marketingCheckbox"
                    class="mx-2"
                    label="Marketing Checkbox"
                    hide-details="auto"
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                 I consent to Techniquest contacting me via email in line with the <a href="https://www.techniquest.org/terms-conditions/privacy-policy/marketing/" target="_blank"> Marketing Privacy</a>

                  </p>
                </v-col>
                <!-- The Data processing Checkbox -->
                <v-col cols="12" class="my-0 py-0">
                  <v-checkbox
                    v-model="editUserForm.dataProcessingCheckbox"
                    class="mx-2"
                    label="Data Processing Checkbox"
                    hide-details="auto"
                  ></v-checkbox>
                  <p
                    class="caption grey--text text--darken-1 pa-1"
                    style="text-align: justify !important"
                  >
                    By checking this box you agree with the storage and handling
                    of your data by this website in accordance with our <span
                      @click="dialog1 = true"
                      class="primary--text text-decoration-underline"
                      style="cursor: pointer !important"
                      >Privacy Policy</span>
                  </p>
                </v-col>
              </v-row>
            </v-form>
            <!--/edit-users-form-->
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              align="end"
              class="ma-0 pa-0"
              justify="bottom"
            >
              <v-row class="pa-0">
                <v-col cols="12" class="ma-0 pa-0" align="end">
                  <v-btn
                    color="white"
                    class="mr-1 primary--text"
                    @click="editUserFlag = !editUserFlag"
                    ><v-icon size="13" left>icons8-delete</v-icon>Cancel</v-btn
                  >

                  <v-btn
                    color="primary"
                    class="mr-3 px-7 "
                    @click="saveEdited()"
                    ><v-icon small left> icons8-email-send</v-icon>Save</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
      <!--edit-users-col -->

      <!-- invite-users-link-dialog-->
      <v-dialog v-model="changeWindowsFlag" width="500">
        <v-card>
          <v-card-title class="primary white--text">
            INVITE USER
          </v-card-title>
          <v-card-text class="mt-5 mx-0 pa-0">
            <InviteUserDialog />
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="changeWindowsFlag = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--/invite-users-link-dialog-->
       <v-dialog
      v-model="dialog1"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          Privacy and Terms & Conditions
          <v-spacer></v-spacer>

          <v-icon @click="dialog1 = false">mdi-close</v-icon>
        </v-toolbar>

        <PrivacyTermsConditions />
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog1 = false">
            Read
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-row>
  </v-layout>
</template>

<script>
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";
import axios from "axios";
import InviteUserDialog from "./InviteUser.vue";
import PrivacyTermsConditions from "../../page-components/PrivacyTermsConditions"

export default {
  name: "Users",
  components: {
    InviteUserDialog,
    PrivacyTermsConditions,
  },
  data() {
    return {
      valid: true,
      search: "",
      schoolNameFilter:"",
      userFilter:"",
      schoolItems: [],
      userLevelFilter:"",
      userLevelItems:[{name: 'Standard', value:'10'},{name:"Admin", value:'100'}],
      mCb:[{name: 'Checked', value: 'true'}, {name: 'Unchecked', value: 'false'}],
      dCb:[{name: 'Checked', value: 'true'}, {name: 'Unchecked', value: 'false'}],
        WelshRating:[
      {name: 'Red', value:'red'},
      {name: 'Amber', value:'amber'},
      {name: 'Yellow', value:'yellow'},
      {name: 'Green', value:'green'}
    ],locationFilter:"",
      marketingCheckboxFilter:"",
      dataProcessingCheckboxFilter:"",
      dialog: false,
      dialog1:false,
      dates: [], // date range filtering
      menu: false,
      headers: [
        {
          text: "Name",
          align: "start",
          filterable: false,
          value: "fullName",
        },
        { text: "Email", value: "email" },
        { text: "Position", value: "position" },
        { text: "Phone number", value: "telephoneNumber" },
        { text: "Registered", value: "accountCreatedAt" },
        { text: "School Name", value:"schoolName",  filter: value => {
            if (!this.schoolNameFilter) return true
            return value === this.schoolNameFilter;
          },},
        { text: "Location", value:"location", filter: value => {
            if (!this.locationFilter) return true
            return value === this.locationFilter;
          },},
          { text: "School Meals", value:"freeSchoolMeals"},
          {text: "WG Rating", value:"WGRating"},
        { text: "Marketing", value:"marketingCheckbox", filter: value => {
             if(!this.marketingCheckboxFilter) {return true}  
            return value === JSON.parse(this.marketingCheckboxFilter);
          },},
        { text: "Data Processing", value:"dataProcessingCheckbox", filter: value => {
            if (!this.dataProcessingCheckboxFilter) return true
            return value === JSON.parse(this.dataProcessingCheckboxFilter);
          },},
         { text: "User Level", value:"userTypeId", align: ' d-none', filter: value => {
            if (!this.userLevelFilter) return true
            return value==this.userLevelFilter;
          },},
          { text: "Suspended", value:"suspendUser"},

        {
          text: "Actions",
          value: "actions",
          sortable: false,
          hidden: false,
          align: "end",
        },
      ],

      headersCSV: {
        fullName: "Name",
        email: "Email",
        position: "Position",
        telephoneNumber: "Phone Number",
        accountCreatedAt: "Registered",
        dataProcessingCheckbox: "Data Processing",
        marketingCheckbox: "Marketing",
        schoolNmae: "School Name",
        location: "Location",
        suspendUser:"Suspended",
        freeSchoolMeals:"School Meals",
        WGRating:"WG Rating",
      },
 locationDropdown: [
      { name: "Blaenau Gwent County Borough",welsh:'true' },
      { name: "Bridgend County Borough",welsh:'true' },
      { name: "Caerphilly County Borough",welsh:'true' },
      { name: "Cardiff",welsh:'true' },
      { name: "Carmarthenshire ",welsh:'true' },
      { name: "Ceredigion",welsh:'true' },
      { name: "Conwy County Borough",welsh:'true' },
      { name: "Denbighshire",welsh:'true' },
      { name: "Flintshire",welsh:'true' },
      { name: "Gwynedd",welsh:'true' },
      { name: "Isle of Anglesey",welsh:'true' },
      { name: "Merthyr Tydfil",welsh:'true' },
      { name: "Monmouthshire",welsh:'true' },
      { name: "Neath Port Talbot",welsh:'true' },
      { name: "Newport",welsh:'true' },
      { name: "Pembrokeshire",welsh:'true' },
      { name: "Powys",welsh:'true' },
      { name: "Rhondda Cynon Taf",welsh:'true' },
      { name: "Swansea",welsh:'true' },
      { name: "The Vale of Glamorgan",welsh:'true' },
      { name: "Torfaen",welsh:'true' },
      { name: "Wrexham",welsh:'true' },
      { name: "England",welsh:'false' },
      { name: "Scotland",welsh:'false' },
      { name: "Northern Ireland",welsh:'false' },
    ],
    
      exportUsers: [],
      users: [],
      usersLevel: [
        { text: "Standard", value: '10' },
        { text: "Admin", value: '100' },
      ],
      changeWindowsFlag: false, // open invite user window
      isTheUserSuspend: "",
      //edit user form
      editedIndex: -1,
      editedId: null,
      editUserForm: {
        fullName: "",
        email: "",
        userTypeId: "",
        modifiedTimestamp: "",
        modifiedBy: "",
        schoolName:"",
        location:"",
        suspendUser:"",
        freeSchoolMeals: "",
        WGRating:"",
      },
      editUserFlag: false, // open edit user window
      //validation rules
      nameRules: [(v) => !!v || "Full name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
       percentageOfFreeSchoolMeals: [
      (v) => !!v || "Perchentage of pupils on Free School Meals",
    ],
     WGRatingRule:[
       (v) => !!v || "Welsh Government School Rating is required",
    ],
    };
  },
  computed: {
    
    buttonText(){
      if(this.isTheUserSuspend === true){
        return "REACTIVATE User";
      }else{
        return "SUSPEND USER"
      }
    },
    filterSchools(){
        for(var i=0; i< this.users.length; i++){
          if(!this.schoolItems.includes(this.users[i].schoolName)&& this.users[i].schoolName != undefined){
            this.schoolItems.push(this.users[i].schoolName);
          }
        }
          return this.schoolItems;
    },
    filterLocationDropdown(){
        var objLoc = [];
      for (var i = 0; i < this.locationDropdown.length; i++) {
        objLoc.push(this.locationDropdown[i].name);
      }
      return objLoc;
    },
    colsNumber() {
      if (this.editUserFlag) {
        return 6;
      } else {
        return 12;
      }
    },
    datesRange() {
      return this.dates.join(" - ");
    },
    filterUsers() {
      var self = this;
      var fUsers = [];
      if (this.dates.length != 0) {
        for (var i = 0; i < this.users.length; i++) {
          if (
            this.$moment(self.users[i].accountCreatedAt) >= this.$moment(self.dates[0]) &&
            this.$moment(self.users[i].accountCreatedAt) <= this.$moment(self.dates[1])
          ) {
            fUsers.push(self.users[i]);
          }
        }
        return fUsers;
      } else {
        return this.users;
      }
    },
    formatExportUsers() {
      this.exportUsers = [];
      for (var i = 0; i < this.filterUsers.length; i++) {
        if(this.filterUsers[i].fullName != ''){
          var fullName = this.filterUsers[i].fullName;
        }else{
          var fullName= "No data";
        }
        

         if(this.filterUsers[i].email != ''){
           var email = this.filterUsers[i].email;
        }else{
          var email = "No data";
        }
        

         if(this.filterUsers[i].position != ''){
           var position = this.filterUsers[i].position;
        }else{
          var position = "No data";
        }
        

         if(this.filterUsers[i].telephoneNumber != ''){
           var telephoneNumber = this.filterUsers[i].telephoneNumber;
        }else{
          var telephoneNumber = "No data";
        }
        

         if(this.filterUsers[i].accountCreatedAt != ''){
           var accountCreatedAt = this.$moment(this.filterUsers[i].accountCreatedAt).format("DD/MM/YYYY");
        }else{
          var accountCreatedAt = "No data";
        }
        
         if(this.filterUsers[i].marketingCheckbox === true){   
           var marketingCheckbox = 'Yes';
        }else if(this.filterUsers[i].marketingCheckbox === false){
          var marketingCheckbox = "No"
          }else{
          var marketingCheckbox = "No data";
        }
     

         if(this.filterUsers[i].dataProcessingCheckbox === true){
           var dataProcessingCheckbox ="Yes";
        }else if(this.filterUsers[i].dataProcessingCheckbox === false){
          var dataProcessingCheckbox = "No";
        }
        else{
          var dataProcessingCheckbox = "No data";
        }
        

         if(this.filterUsers[i].schoolName != ''){ 
           var schoolName = this.filterUsers[i].schoolName;
        }else{
          var schoolName = "No data";
        }
       

         if(this.filterUsers[i].location != ''){
           var location = this.filterUsers[i].location;
        }else{
          var location = "No data";
        }
        

         if(this.filterUsers[i].suspendUser === true){
           var suspendUser = 'Yes';
        }else if(this.filterUsers[i].suspendUser === true){
          var suspendUser = "No";
        }
        else{
          var suspendUser = "No data";
        }
        

        this.exportUsers.push({
          fullName: fullName,
          email: email,
          position: position,
          telephoneNumber: telephoneNumber,
          accountCreatedAt: accountCreatedAt,
          marketingCheckbox: marketingCheckbox,
          dataProcessingCheckbox: dataProcessingCheckbox,
          schoolName:schoolName,
          location:location,
          suspendUser: suspendUser,
        });
      }
      return this.exportUsers;
    },
  },
  methods: {
    getLocationWelshValue(item){
      var self = this;
      for( var i=0; i< self.locationDropdown.length; i++){
        if(item === self.locationDropdown[i].name){
          if(self.locationDropdown[i].welsh=='false'){
            self.editUserForm.WGRating="";
            self.editUserForm.freeSchoolMeals="";
          }
          return self.locationDropdown[i].welsh;
      }
      }
    },
    suspendUserFunction(){
      if(this.isTheUserSuspend === false){
        this.editUserForm.suspendUser = true;
        this.saveEdited();
      }else{
        this.editUserForm.suspendUser = false;
        this.saveEdited();
      }
    },
    formatDate(date) {
      date = this.$moment(date).format("DD MMM YYYY");
      return date;
    },
    editItem(item) {
      //console.log(JSON.stringify(item));
      this.editedIndex = this.users.indexOf(item);
      this.editUserForm = Object.assign({}, item);
      this.editedId = item.id;
      this.editUserFlag = true;
      this.isTheUserSuspend = item.suspendUser;
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },

    saveEdited() {
      var self = this;
      if (this.$refs.editForm.validate()) {
        self.editUserForm.modifiedTimestamp = self.$moment().toISOString();
        self.editUserForm.modifiedBy = self.$store.getters.currUser.fullName;
        //console.log(self.$store.getters.currUser.fullName);
        //console.log(self.editedId);

        self.$firebase.db
          .collection("users")
          .doc(self.editedId)
          .set(self.editUserForm)
          .then((docRef) => {
            self.$snotify.info("The user was edited.");
          })
          .catch((error) => {
            //console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });

        Object.assign(self.users[self.editedIndex], self.editUserForm);
        var id = self.editUserForm._id;
        delete self.editUserForm._id;

        self.editUserFlag = false;
      } else {
        //  console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    deleteItem(item) {
      const index = this.users.indexOf(item);
      var id = item.id;
      //console.log("ID: " + id);

      this.$snotify.confirm(
        "Are you sure you want to delete this user?",
        "Delete user",
        {
          titleMaxLength: 250,
          maxOnScreen: 1,
          closeOnClick: false,
          pauseOnHover: true,
          position: SnotifyPosition.centerCenter,
          buttons: [
            //Yes
            {
              text: "Yes",
              action: (toast) => this.yesAction(id, index, toast),
              bold: false,
            },
            //No
            { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
          ],
        }
      );
    },
    yesAction(id, index, toast) {
      // delete user from firebase auth
      var functionsURL = this.$store.getters.FirebaseFunctionsURL;
      axios
        .get(functionsURL + "deleteUserFromAuthentication?userID=" + id)
        .then((response) => {
          // console.log("response result" + response.data.result);
          if (response.data.result === true) {
            this.$snotify.info("The user was deleted.");
          } else {
            // console.log(
            //   "Error deleting user " + JSON.stringify(response.data, null, 2)
            // );
            this.$snotify.error(
              "An error occured while trying to delete this user."
            );
          }
        });

        
      var self = this;
      // delete user from firebase collection
      this.$firebase.db
        .collection("users")
        .doc(id)
        .delete()
        .then(() => {
          self.$snotify.success("The user was deleted.");
        })
        .catch((error) => {
          self.$snotify.error(error);
        });
      this.users.splice(index, 1); // remove user from datatable
      this.$snotify.remove(toast.id);
    },
    exportCSVFile(headers, items, fileTitle) {
      //console.log("headers:" + JSON.stringify(headers, null, 2));

      if (headers && items[0] != headers) {
        items.unshift(headers);
      }
      //console.log("items: " + JSON.stringify(items[1], null, 2));
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = this.convertToCSV(jsonObject);
      // console.log(JSON.stringify(csv, null, 2))
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    // convert object to csv
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
  },
  created() {
    var self = this;
    this.$firebase.db.collection("users").onSnapshot((querySnapshot) => {
      self.users = [];
      var Data = [];
      querySnapshot.forEach((doc) => {
        Data = doc.data();
        Data.id = doc.id;
        self.users.push(Data);
      });
    });
  },
};
</script>
